import { InstalledApplication } from '@era/locations-sdk';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export function selectDeviceInstalledApplicationsId(installedApplication: InstalledApplication) {
  const key: string = [
    installedApplication.deviceId,
    installedApplication.bundleIdentifier,
    installedApplication.bundleVersion,
  ].join('-');

  return key;
}

export const adapter: EntityAdapter<InstalledApplication> = createEntityAdapter<InstalledApplication>({
  selectId: selectDeviceInstalledApplicationsId,
});

export type DeviceInstalledApplicationsState = EntityState<InstalledApplication>;

export const initialState: DeviceInstalledApplicationsState = adapter.getInitialState();
